import { preguntas } from '../data/contenido';

/**
 * Preguntas frecuentes. El mismo contenido se declara como FAQPage en el
 * JSON-LD de public/index.html: si cambias una respuesta aca, cambiala alla.
 */
export default function Preguntas() {
  return (
    <section className="preguntas" id="preguntas">
      <div className="envoltura">
        <div className="cabecera" data-reveal="">
          <p className="rotulo">Preguntas frecuentes</p>
          <h2 className="titulo">Lo que más me preguntan</h2>
        </div>

        <dl className="preguntas__lista">
          {preguntas.map((item, i) => (
            <div
              className="pregunta"
              key={item.p}
              data-reveal=""
              style={{ '--retraso': `${Math.min(i, 5) * 60}ms` }}
            >
              <dt>{item.p}</dt>
              <dd>{item.r}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
